import { DateTime } from "@bps/date-time";

import { Tenant, TenantDto } from "./plt-gateway.dtos";

export const toTenant = (dto: TenantDto): Tenant => {
  const { createdDate, updatedDate, ...changeLogRest } = dto.changeLog;

  return {
    ...dto,
    changeLog: {
      ...changeLogRest,
      createdDate: DateTime.fromISO(createdDate) ?? undefined,
      updatedDate: DateTime.fromISO(updatedDate) ?? undefined
    }
  };
};

export const toTenantDto = (dto: Tenant): TenantDto => {
  return {
    ...dto,
    changeLog: {
      ...dto.changeLog,
      createdDate: dto.changeLog.createdDate?.toISO() ?? undefined,
      updatedDate: dto.changeLog.updatedDate?.toISO() ?? undefined
    }
  };
};
